module.exports = __webpack_public_path__ + "12bd379668ab5c3c9888ff1804e460c6.png";